import ServiceTab from 'src/components/ServiceTab/ServiceTab';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import {
    FrameworkActionCreator, AppointmentActionCreator,
    RMTimesActionCreator, WebOpsActionCreator, SpecsActionCreator,
} from 'src/store/states';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    apptCust: state.Appointment.ApptCust,
    specProfile: state.Framework.specProfile,
    additionalServices: state.AdditionalServices,
    webOps: state.WebOps.WebOps,
    webOpChecked: state.WebOps.checkedWebOps,
    maintMenus: state.Menus,
    apptOps: state.Appointment.ApptOps,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    invalidDates: state.RMTimes.invalidDates,
    invalidDatesDept: state.RMTimes.invalidDatesDept,
    apptDept: state.Appointment.Appointment.department,
    apptAdvNum: state.Appointment.Appointment.advisor,
    theme: state.Framework.theme,
    viewMode: state.Framework.viewMode,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    locale: state.Framework.locale,
    appointment: state.Appointment,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    getWebOps: WebOpsActionCreator.GetApptOps,
    getRMTimes: RMTimesActionCreator.GetRMTimes,
    determineDept: AppointmentActionCreator.DetermineDept,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    getInvalidDates: RMTimesActionCreator.GetInvalidDates,
    clearInvalidDates: RMTimesActionCreator.ClearInvalidDates,
    toggleOpsLangLits: WebOpsActionCreator.ToggleOpsLangLits,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceTab);